import { useContext } from 'react';
import { AuthContext, AuthContextValue } from './authContext';

export const useAuth0 = (): AuthContextValue => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth0 must be used within AuthProvider');
  }
  return context;
};

export const useAuth = useAuth0;
